import { RegisterFirmWithManagerPayload } from 'screens/BrokerPortal/screens/Registration/api';
import {
  FIELD_NAMES as DUE_DILIGENCE_DETAILS_FIELD,
  Form as DueDiligenceDetailsForm,
} from 'screens/BrokerPortal/screens/Registration/components/DueDiligenceStep/types';
import { ADDRESS_NAMES } from 'screens/BrokerPortal/screens/Registration/components/Form/Address/types';
import {
  FIELD as PERSONAL_DETAILS_FIELD,
  Form as PersonalDetailsForm,
} from 'screens/BrokerPortal/screens/Registration/components/PersonalDetailsStep/types';
import {
  FIRM_TYPE,
  FIELD_NAMES as REGISTER_FIRM_FIELD,
  Form as RegisterFirmForm,
} from 'screens/BrokerPortal/screens/Registration/components/RegisterFirmStep/types';

const registerFirmWithManagerMapper = (
  registerFirmForm: RegisterFirmForm,
  dueDiligenceForm: DueDiligenceDetailsForm,
  personalDetailsForm: PersonalDetailsForm,
): RegisterFirmWithManagerPayload =>
  ({
    addressLine1: registerFirmForm[ADDRESS_NAMES.ADDRESS_LINE_1],
    addressLine2: registerFirmForm[ADDRESS_NAMES.ADDRESS_LINE_2],
    addressLine3: registerFirmForm[ADDRESS_NAMES.ADDRESS_LINE_3],
    city: registerFirmForm[ADDRESS_NAMES.CITY],
    county: registerFirmForm[ADDRESS_NAMES.COUNTY],
    postcode: registerFirmForm[ADDRESS_NAMES.POSTCODE],
    fcaNumber: registerFirmForm[REGISTER_FIRM_FIELD.FCA_NUMBER],
    firmEmail: registerFirmForm[REGISTER_FIRM_FIELD.FIRM_EMAIL],
    firmName: registerFirmForm[REGISTER_FIRM_FIELD.FIRM_NAME],
    firmPhone: registerFirmForm[REGISTER_FIRM_FIELD.FIRM_PHONE]?.replace(/\s/g, '') ?? '',
    firmType: registerFirmForm[REGISTER_FIRM_FIELD.FIRM_TYPE],
    hasPermissionToRegisterFirm: registerFirmForm[REGISTER_FIRM_FIELD.HAS_PERMISSION_TO_REGISTER_FIRM],
    network:
      registerFirmForm[REGISTER_FIRM_FIELD.FIRM_TYPE] === FIRM_TYPE.AR
        ? Number(registerFirmForm[REGISTER_FIRM_FIELD.NETWORK])
        : null,
    club:
      registerFirmForm[REGISTER_FIRM_FIELD.FIRM_TYPE] === FIRM_TYPE.DA
        ? Number(registerFirmForm[REGISTER_FIRM_FIELD.CLUB])
        : null,
    dueDiligence:
      registerFirmForm[REGISTER_FIRM_FIELD.FIRM_TYPE] === FIRM_TYPE.DA
        ? {
            companiesHouseNumber: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.COMPANIES_HOUSE_NUMBER],
            managementDob: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.MANAGEMENT_DOB],
            icoProtectionNumber: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.ICO_PROTECTION_NUMBER],
            financialCrimePolicy: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.FINANCIAL_CRIME_POLICY],
            dataProtectionPolicy: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.DATA_PROTECTION_POLICY],
            treatingCustomerFairlyPolicy: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.TREATING_CUSTOMER_FAIRLY_POLICY],
            disasterRecoveryPolicy: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.DISASTER_RECOVERY_POLICY],
            numberOfComplaintsReceived: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.NUMBER_OF_COMPLAINTS_RECEIVED],
            numberOfComplaintsUpheld: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.NUMBER_OF_COMPLAINTS_UPHELD],
            employeeAccessRemovalProcess: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.EMPLOYEE_ACCESS_REMOVAL_PROCESS],
            piiInPlaceWithFCARequirements:
              dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.PII_IN_PLACE_WITH_FCA_REQUIREMENTS],
            sensitiveDataPolicy: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.SENSITIVE_DATA_POLICY],
            additionalInformation: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.ADDITIONAL_INFORMATION],
            agreedToTermsAndConditions: dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.AGREED_TO_TERMS_AND_CONDITIONS],
            whoCarriesComplianceOversight:
              dueDiligenceForm[DUE_DILIGENCE_DETAILS_FIELD.WHO_CARRIES_COMPLIANCE_OVERSIGHT],
          }
        : null,
    email: personalDetailsForm[PERSONAL_DETAILS_FIELD.EMAIL],
    firstName: personalDetailsForm[PERSONAL_DETAILS_FIELD.FIRST_NAME],
    phone: personalDetailsForm[PERSONAL_DETAILS_FIELD.CONTACT_NUMBER]?.replace(/\s/g, '') ?? '',
    role: personalDetailsForm[PERSONAL_DETAILS_FIELD.ROLE],
    surname: personalDetailsForm[PERSONAL_DETAILS_FIELD.SURNAME],
    howDidUserHearAboutLivemore: personalDetailsForm[PERSONAL_DETAILS_FIELD.HOW_DID_USER_HEAR_ABOUT_LIVEMORE],
    optionalDetails: personalDetailsForm[PERSONAL_DETAILS_FIELD.OPTIONAL_DETAILS],
  } as RegisterFirmWithManagerPayload);

export default registerFirmWithManagerMapper;
